import { useState } from "react";
import { toast } from "react-toastify";

type CopiedValue = string | null;
type CopyFn = (text: string) => Promise<boolean>; // Return success

function fallbackCopyTextToClipboard(text: string) {
  var textArea = document.createElement("textarea");
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = "0";
  textArea.style.left = "0";
  textArea.style.position = "fixed";

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    var successful = document.execCommand("copy");
    var msg = successful ? "successful" : "unsuccessful";
    if (msg === "successful") {
      toast.success("Copied to clipboard!");
    } else {
      toast.error("Fallback: Copying text command was unsuccessful");
    }
  } catch (err) {
    console.error("Fallback: Oops, unable to copy", err);
    toast.error("Fallback: Oops, unable to copy");
  } finally {
    textArea.remove();
  }

  document.body.removeChild(textArea);
}

export function useMyCopyToClipboard(): [CopiedValue, CopyFn] {
  const [copiedText, setCopiedText] = useState<CopiedValue>(null);

  const copy: CopyFn = async (text) => {
    if (!navigator?.clipboard) {
      fallbackCopyTextToClipboard(text);
      return false;
    }
    // Try to save to clipboard then save it in the state if worked
    try {
      await navigator.clipboard.writeText(text);
      toast.success("Copied to clipboard!");
      setCopiedText(text);
      return true;
    } catch (error) {
      fallbackCopyTextToClipboard(text);
      return false;
    }
  };

  return [copiedText, copy];
}
